import {
  partner_bouygues,
  partner_ceref_btp,
  partner_colas_bat,
  partner_eiffage_route,
  partner_eurovia,
  partner_gagneraud_normandie,
  partner_mastello,
  partner_vallois,
  page_logo_decoration,
} from "../../../Imgs/images";

function Partners() {
  return (
    <section className="hp-partners">
      <h2 className="sp-section-title hp-partners-title">
        Ils nous font confiance
      </h2>
      <div className="hp-partners-list">
        <div className="hp-partners-crsl">
          <a
            href="https://www.eiffage.com/"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_bouygues} />
              <img src={partner_bouygues} alt="logo SPenseignement" />
            </picture>
          </a>
          <a
            href="https://www.veolia.com/fr"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_ceref_btp} />
              <img src={partner_ceref_btp} alt="logo SPenseignement" />
            </picture>
          </a>
          <a
            href="https://www.hsbc.fr/"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_colas_bat} />
              <img src={partner_colas_bat} alt="logo SPenseignement" />
            </picture>
          </a>
          <a
            href="https://www.rungisinternational.com/"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_eiffage_route} />
              <img src={partner_eiffage_route} alt="logo SPenseignement" />
            </picture>
          </a>
          <a
            href="https://www.eiffage.com/"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_eurovia} />
              <img src={partner_eurovia} alt="logo SPenseignement" />
            </picture>
          </a>
          <a
            href="https://www.veolia.com/fr"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_gagneraud_normandie} />
              <img
                src={partner_gagneraud_normandie}
                alt="logo SPenseignement"
              />
            </picture>
          </a>
          <a
            href="https://www.hsbc.fr/"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_mastello} />
              <img src={partner_mastello} alt="logo SPenseignement" />
            </picture>
          </a>
          <a
            href="https://www.rungisinternational.com/"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_vallois} />
              <img src={partner_vallois} alt="logo SPenseignement" />
            </picture>
          </a>
        </div>
        <div className="hp-partners-crsl">
          <a
            href="https://www.eiffage.com/"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_bouygues} />
              <img src={partner_bouygues} alt="logo SPenseignement" />
            </picture>
          </a>
          <a
            href="https://www.veolia.com/fr"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_ceref_btp} />
              <img src={partner_ceref_btp} alt="logo SPenseignement" />
            </picture>
          </a>
          <a
            href="https://www.hsbc.fr/"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_colas_bat} />
              <img src={partner_colas_bat} alt="logo SPenseignement" />
            </picture>
          </a>
          <a
            href="https://www.rungisinternational.com/"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_eiffage_route} />
              <img src={partner_eiffage_route} alt="logo SPenseignement" />
            </picture>
          </a>
          <a
            href="https://www.eiffage.com/"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_eurovia} />
              <img src={partner_eurovia} alt="logo SPenseignement" />
            </picture>
          </a>
          <a
            href="https://www.veolia.com/fr"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_gagneraud_normandie} />
              <img
                src={partner_gagneraud_normandie}
                alt="logo SPenseignement"
              />
            </picture>
          </a>
          <a
            href="https://www.hsbc.fr/"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_mastello} />
              <img src={partner_mastello} alt="logo SPenseignement" />
            </picture>
          </a>
          <a
            href="https://www.rungisinternational.com/"
            target="_blank"
            rel="noreferrer"
            className="hp-partners-link"
          >
            <picture className="hp-partners-logo">
              <source srcSet={partner_vallois} />
              <img src={partner_vallois} alt="logo SPenseignement" />
            </picture>
          </a>
        </div>
      </div>
      <div className="hp-partners-numbers">
        <div className="hp-number-element">
          <div className="hp-number-element-main">
            <span>212</span>
          </div>
          <span className="hp-number-element-text">Formations effectuées</span>
        </div>
        <div className="hp-number-element">
          <div className="hp-number-element-main">
            <span>95</span>
            <span className="hp-number-element-percentage">%</span>
          </div>
          <span className="hp-number-element-text">
            de réussites à nos formations
          </span>
        </div>
        <div className="hp-number-element">
          <div className="hp-number-element-main">
            <span>99</span>
            <span className="hp-number-element-percentage">%</span>
          </div>
          <span className="hp-number-element-text">
            de satisfaction clients
          </span>
        </div>
      </div>
      <div className="hp-partners-decoration">
        <picture className="hp-partners-deco-top-left">
          <source srcSet={page_logo_decoration} />
          <img
            src={page_logo_decoration}
            alt="icone triangle gris semi transparent"
          />
        </picture>
        <picture className="hp-partners-deco-middle-right">
          <source srcSet={page_logo_decoration} />
          <img
            src={page_logo_decoration}
            alt="icone triangle gris semi transparent"
          />
        </picture>
      </div>
    </section>
  );
}

export default Partners;
